// Direct external lab certificate verification URL builders.
// Lab values are normalised (uppercased + trimmed) before matching.
// User-specified formats (Feb 2026):
//   IGI: https://www.igi.org/verify-your-report/?r=<CERT>
//   GIA: https://www.gia.edu/report-check?locale=en_US&reportno=<CERT>
//   HRD: https://my.hrdantwerp.com/?record_number=<CERT>
export function buildCertVerifyUrl(lab, certNo) {
  if (!lab || !certNo) return null;
  const L = String(lab).trim().toUpperCase();
  // Strip ALL whitespace from cert number — never leak spaces into the URL.
  const N = String(certNo).replace(/\s+/g, "");
  if (!N) return null;
  if (L === "IGI") return `https://www.igi.org/verify-your-report/?r=${encodeURIComponent(N)}`;
  if (L === "GIA") return `https://www.gia.edu/report-check?locale=en_US&reportno=${encodeURIComponent(N)}`;
  if (L === "HRD") return `https://my.hrdantwerp.com/?record_number=${encodeURIComponent(N)}`;
  return null;
}
